import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule } from '@angular/material';
import { FileModule } from '@commons/file/file.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { WizFileModule } from '@commons/wiz-file/wiz-file.module';
import { FormComponent } from '@domains/applications/form/form.component';

@NgModule({
  declarations: [FormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SvgIconModule,
    MatInputModule,
    MatFormFieldModule,
    FileModule,
    WizFileModule,
    TrackerModule,
  ],
  exports: [FormComponent],
})
export class FormModule {}
